import type { CarrierCarrierConfigurable } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const carrierConfigurables = {
  search: {
    queryKey: 'carrier-service/carrier-configurables',
    configurationType: 'cached' as const,
    fn: async (carrierId: string) => {
      const { data } = await GatewayAxiosClient.get<CarrierCarrierConfigurable[]>(
        `/carrier-proxy/api/v1/carriers/${carrierId}/configurables`,
      );

      return data;
    },
  },
  get: {
    queryKey: 'carrier-service/carrier-configurables/id',
    configurationType: 'no-cache' as const,
    fn: async (carrierId: string, carrierConfigurableId: string) => {
      const { data } = await GatewayAxiosClient.get<CarrierCarrierConfigurable>(
        `/carrier-proxy/api/v1/carriers/${carrierId}/configurables/${carrierConfigurableId}`,
      );

      return data;
    },
  },
};
